export default __webpack_public_path__ + "static/media/1816.e4606a7b.png";